export enum IntegrationType {
  ApiToken = 'api-token',
  Webhook = 'webhook',
}
